module.exports = __webpack_public_path__ + "img/objects-align-right.c2660539.svg";